import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import {
  BgOverlay,
  Container,
  Content,
  CTAText,
  Section,
  SquareCTA,
  SquareTitle,
  StyledBlackSection,
  StyledWhiteSection,
  WhiteCTAText,
  WhiteSquare,
} from '../styles/SharedBlockStyledComponents';

export default function BlockHomeHardcoded() {
  return (
    <>
      <Section
        className="relative mt-16"
        style={{ height: '90vh', minHeight: '600px' }}
      >
        <Container>
          {/* bg photo */}
          <StaticImage
            src="../images/home-bg-1-bw.png"
            alt="Background"
            className="bg--photo"
            style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              height: '100%',
              zIndex: 1,
            }}
            placeholder="none"
            layout="fullWidth"
          />
          <BgOverlay />

          <Content className="homepage-hero">
            <h1 className="h1">Keep the world moving</h1>
            <WhiteSquare className="left">
              <SquareTitle>
                The Routing Company&#39;s algorithm powers the world&#39;s most efficient 
                on-demand fleets
              </SquareTitle>
              <SquareCTA to="/algorithm">Learn how it works &gt;</SquareCTA>
            </WhiteSquare>
          </Content>
        </Container>
      </Section>

      <StyledWhiteSection>
        <Container className="column center">
          <Content className="column center"
          style={{     
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
            <WhiteCTAText>
              Getting on-demand and logistics routing right, at scale, means adapting constantly. 
            </WhiteCTAText>
            <WhiteCTAText className="mt-8">
              That kind of real-time, coordinated reactivity requires one heck of an algorithm.
            </WhiteCTAText>
            <WhiteCTAText className="mt-8">
              We ought to know; we built it.
            </WhiteCTAText>
            <Link
              to="/our_story"
              className="btn--rounded bg--secondary mt-8"
              style={{ width: 'fit-content' }}
            >
              Read our story
            </Link>
          </Content>
        </Container>
      </StyledWhiteSection>

      <Section className="relative">
        <Container>
          <StaticImage
            src="../images/home-bg-2.png"
            alt="Background"
            className="bg--photo"
            style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              height: '100%',
              zIndex: 1,
              background: 'rgba(0, 0, 0, 0.75)',
            }}
            placeholder="none"
            layout="fullWidth"
          />
          <BgOverlay style={{ background: 'rgba(0, 0, 0, 0.75)' }} />
          <Content className="homepage-analytics" $maxWidth="1120px">
            <h2>
              Road-tested algorithm
            </h2>
            <p>
              <span className="percent">5M+ </span> trips across 50+ global deployments
            </p>
            <p>
              <span className="percent">20+</span> peak passengers per vehicle revenue hour
            </p>
            <p>
              <span className="percent">3-8x</span> higher seat utilization than alternative software
            </p>
          </Content>
        </Container>
      </Section>

      <Section className="relative">
        <Container>
          <StaticImage
            src="../images/home-bg-5.jpg"
            alt="Background"
            className="bg--photo"
            style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              height: '100%',
              zIndex: 1,
            }}
            placeholder="none"
            layout="fullWidth"
          />
          <Content className="homepage-zoox" $maxWidth="1120px">
            <div
              style={{
                background: 'rgba(0,0,0,0.45)',
                padding: '2.5rem',
                display: 'inline-block',
                boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
              }}
            >
              <h2
                className="h2 mb-4"
                style={{
                  color: '#fff',
                  textShadow: '0 2px 8px rgba(0,0,0,0.25)',
                }}
              >
                Zoox enters into a <br /> non-exclusive technology <br />{' '}
                license agreement with TRC
              </h2>
              <div style={{display:"flex", justifyContent:"center", alignItems:"center", flexDirection:"row", gap:"1.5rem"}}>
                <Link to="/contact" className="btn--rounded bg--tan mt-16">
                  Get in touch about licensing our products
                </Link>
                <a href="https://techcrunch.com/2025/08/20/zoox-taps-ex-uberpool-execs-startup-for-routing-software-help/">
                  <StaticImage src="../images/tc-logo.png" alt="tech crunch logo" />
                </a>
              </div>
            </div>
          </Content>
        </Container>
      </Section>

      <StyledWhiteSection>
        <Container className="column center">
          <WhiteCTAText>We define “optimal” according to your needs</WhiteCTAText>
          <WhiteCTAText className="mt-12">
            Our routing algorithm reoptimizes every 15 seconds based on your
            custom inputs.
          </WhiteCTAText>
          <WhiteCTAText className="mt-12">(Yes, even at massive scale.)</WhiteCTAText>
          <Link to="/algorithm" className="btn--rounded bg--secondary mt-6">
            Learn how it works
          </Link>
        </Container>
      </StyledWhiteSection>

      <Section className="relative">
        <Container>
          <StaticImage
            src="../images/home-bg-6.png"
            alt="Background"
            className="bg--photo"
            style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              height: '100%',
              zIndex: 1,
            }}
            placeholder="none"
            layout="fullWidth"
          />
          <BgOverlay />
          <Content className="homepage-product" $maxWidth="1120px">
            <h2 className="h2 mb-4">We don&#39;t like empty seats</h2>
            <p className="mb-8">
              Our Pingo™ platform moves more people in fewer vehicles without
              sacrificing ETAs.
            </p>
            <Link to="/products" className="btn--rounded bg--tan mt-16">
              See our products
            </Link>
          </Content>
        </Container>
      </Section>

      <StyledBlackSection>
        <Container className="column center">
          <CTAText>Want to optimize your transit operations?</CTAText>
          <CTAText className="mt-12">
            Interested in licensing our technology?
          </CTAText>
          <Link to="/contact" className="btn--rounded bg--tan mt-6">
            Talk to us
          </Link>
        </Container>
      </StyledBlackSection>
    </>
  );
}
